import React from "react";
import MainPagetitle from "../../layouts/MainPagetitle";

export const CollectionPolicy = () => {
  return (
    <>
      <MainPagetitle
        mainTitle="Collection Policy"
        pageTitle="Collection Policy"
        parentTitle="Home"
      />
      <div className="container-fluid cert_docs_container">
        <div class="card p-4">
          <h2 class="modal-title mb-3">Collections Flow for Missed Payments</h2>
          <b class="d-block mb-2">
            Step 1: Reminder Communication (Day 1 - Day 2 post Due Date)
          </b>

          <div class="d-flex flex-wrap flex-lg-nowrap">
            <b>Action:</b>
            <ul class="pl-5 mb-3">
              <li>
                Collection agents to call the borrower with a friendly tone to
                remind them of the missed payment and request immediate
                repayment.
              </li>
              <li>
                Understand the reason for non-payment and capture the response
                in the Loan Origination System (LOS).
              </li>
            </ul>
          </div>

          <div class="d-flex flex-wrap flex-lg-nowrap">
            <b>Important:</b>
            <ul class="pl-5 mb-3">
              <li>
                Share digital payment links to facilitate instant repayment.
              </li>
              <li>
                Offer a one-time grace period of up to 2–3 days if a genuine
                reason is provided.
              </li>
            </ul>
          </div>

          <b class="d-block mb-2">
            Step 2: Personal Visit Attempt + Reference Calling (Day 3 - Day 5
            post Due Date)
          </b>

          <div class="d-flex flex-wrap flex-lg-nowrap">
            <b>Action:</b>
            <ul class="pl-5 mb-3">
              <li>
                Field collection agents to visit the borrower’s office or
                residential address.
              </li>
              <li>
                Discuss payment obligations and clearly explain the consequences
                of continued non-payment.
              </li>
              <li>
                <b>Contact borrower’s provided references</b> (family members,
                friends, or office contacts) politely to inform about the
                overdue payment.
              </li>
              <li>
                Reiterate the need for immediate repayment to avoid further
                escalation.
              </li>
            </ul>
          </div>

          <div class="d-flex flex-wrap flex-lg-nowrap">
            <b>Objective:</b>
            <ul class="pl-5 mb-3">
              <li>
                Collect the overdue payment or secure a signed commitment letter
                for payment within 3 days.
              </li>
              <li>
                Encourage timely repayments through responsible social
                engagement, ensuring professionalism and strict adherence to
                data privacy norms.
              </li>
            </ul>
          </div>

          <b class="d-block mb-2">
            Step 3: Notice of Default (Day 6 - Day 9 post Due Date)
          </b>

          <div class="d-flex flex-wrap flex-lg-nowrap">
            <b>Action:</b>
            <ul class="pl-5 mb-3">
              <li>
                Issue a formal <b>Notice of Default</b> via registered email,
                SMS, and/or postal communication.
              </li>
              <li>
                <b>
                  Send an official recovery email from the company’s authorized
                  recovery email ID to the borrower’s official email ID.
                </b>
              </li>
              <li>
                Highlight applicable penal charges, potential legal recovery
                actions, and credit bureau reporting consequences.
              </li>
            </ul>
          </div>

          <b class="d-block mb-2">
            Step 4: Legal & Recovery Escalation (Post 90 Days of Due Date)
          </b>

          <div class="d-flex flex-wrap flex-lg-nowrap">
            <b>Action:</b>
            <ul class="pl-5 mb-3">
              <li>
                If no positive response is received even after 90 days from the
                due date, escalate the case to the Legal Team.
              </li>
              <li>
                Initiate legal notices and recovery proceedings as per policy
                guidelines.
              </li>
            </ul>
          </div>

          <b>Also:</b>
          <p>Mark the account as delinquent in the Credit Bureau Reporting.</p>

          <b>Additional Notes</b>
          <ul class="pl-5 mb-3">
            <li>
              <b>Late Payment Interest:</b> 2% Penal Charges, calculated on a
              daily basis.
            </li>
            <li>
              <b>Credit Bureau Reporting:</b> Ensure reporting of non-payment
              within 15 calendar days from the due date.
            </li>
            <li>
              <b>Special Cases:</b> In the event of the borrower’s death or
              verified financial distress, initiate a settlement process instead
              of standard recovery actions.
            </li>
          </ul>

          <b>
            In event of a default beyond 10 days , there shall be multiple
            attempts to connect with customer through phone, physical visit to
            recorded addresses and by contacting references.  The Threshold days
            of start of each event in collection effort is mentioned above in 
            detailed matrix. 
          </b>
        </div>
      </div>
    </>
  );
};
